import { useCallback, useEffect, useState } from "react";
import { Dock } from "react-dock";
import ClienteInfoTabs from "../../../components/clienteinfotabs/clienteinfotabs.jsx";
import "./clientescad.css";
import api from "../../../services/api.js";

const buildInitialClienteState = () => ({
  cdcli: "",
  cdemp: localStorage.getItem("cdemp") || 1,
  tipocli: "F",
  decli: "",
  fantcli: "",
  cnpj_cpfcli: "",
  insc_rgcli: "",
  dddcli: "",
  fonecli: "",
  nasctocli: "",
  endcli: "",
  numcli: "",
  compcli: "",
  cepcli: "",
  estcli: localStorage.getItem("estemp") || "",
  cidcli: localStorage.getItem("cidemp") || "",
  baicli: localStorage.getItem("baiemp") || "",
  ativocli: "S",
  contato: "",
  cargo: "",
  dddcont: "",
  fonerespcli: "",
  nascimento: "",
  emailcli: "",
  sitecli: "",
  endent: "",
  baient: "",
  cident: "",
  estent: "",
  cepent: "",
  comEnt: "",
  fotocli: "",
  contabil: "",
});

const buildInitialSocioState = () => ({
  AUTOCOD: "",
  CDEMP: localStorage.getItem("cdemp") || "",
  DTADMISSAO: "",
  DTAUTORIZACAO: "",
  DTFILICAO: "",
  CDCLI: "",
  CHAVEPIX: "",
  CLASSE: "",
  CONTA: "",
  DEPARTAMENTO: "",
  CURSO: "",
  DIGAGENCIA: "",
  DIGCONTA: "",
  ESTADOCIVIL: "Solteiro",
  NATURALIDADE: "",
  NIVEL: "",
  OPCONTRIB: "Desconto em folha",
  REGTRAB: "",
  SITUACAO: "Ativo",
  TIPOCONTA: "",
  TITULACAO: "",
  TPCHAVEPIX: "",
  UNIDADE: "",
  MATRICULA: "",
  BANCO: "",
  AGENCIA: "",
});

const normalizeDateForDatabase = (value) => {
  if (!value) {
    return null;
  }

  const date = new Date(value);
  if (Number.isNaN(date.getTime())) {
    return null;
  }

  date.setMinutes(date.getMinutes() + date.getTimezoneOffset());
  return date.toISOString().split("T")[0];
};

const normalizeClientePayload = (cliente) => {
  const payload = { ...cliente };

  if (payload.nascimento) {
    payload.nascimento = normalizeDateForDatabase(payload.nascimento);
  } else {
    delete payload.nascimento;
  }

  if (payload.nasctocli) {
    payload.nasctocli = normalizeDateForDatabase(payload.nasctocli);
  } else {
    delete payload.nasctocli;
  }

  return payload;
};

const normalizeSocioPayload = (socio, clientId) => {
  const payload = { ...socio, CDCLI: clientId };

  ["DTADMISSAO", "DTAUTORIZACAO", "DTFILICAO"].forEach((field) => {
    if (payload[field]) {
      payload[field] = normalizeDateForDatabase(payload[field]);
      return;
    }
    delete payload[field];
  });

  return payload;
};

function ClienteCad() {
  const [show, setShow] = useState(false);
  const [operacao, setOperacao] = useState("");
  const [codcli, setCodcli] = useState("");
  const [tipoemp, setTipoemp] = useState();
  const [titulo, setTitulo] = useState();
  const [dadosCliente, setDadosCliente] = useState(buildInitialClienteState);
  const [dadosSocio, setDadosSocio] = useState(buildInitialSocioState);

  const clearFormData = useCallback(() => {
    setCodcli("");
    setDadosCliente(buildInitialClienteState());
    setDadosSocio(buildInitialSocioState());
  }, []);

  const fetchClientData = useCallback(async (clientId) => {
    try {
      const resp = await api.get(`/t_cli/${clientId}`, {
        params: {
          user: localStorage.getItem("user"),
        },
      });

      setDadosCliente(resp.data || buildInitialClienteState());
    } catch (err) {
      setDadosCliente(buildInitialClienteState());
      alert(`Erro ao buscar dados do cliente: ${err.message}`);
    }
  }, []);

  const fetchDadosSocio = useCallback(async (clientId) => {
    try {
      const resp = await api.get("/t_socio", {
        params: {
          user: localStorage.getItem("user"),
          cliente: clientId,
        },
      });

      const rows = resp.data?.rows || [];
      setDadosSocio(rows[0] || buildInitialSocioState());
    } catch (err) {
      setDadosSocio(buildInitialSocioState());
      alert(`Erro ao buscar dados do socio: ${err.message}`);
    }
  }, []);

  useEffect(() => {
    const handleOpenSidebar = (event) => {
      const detail = event?.detail || {};
      const nextOperacao = detail.operacao || "";
      const nextCodcli = detail.codcli || "";

      setShow(true);
      setOperacao(nextOperacao);
      setCodcli(nextCodcli);

      if (nextOperacao === "Incluir" || !nextCodcli) {
        clearFormData();
        return;
      }

      setDadosCliente(buildInitialClienteState());
      setDadosSocio(buildInitialSocioState());
      fetchClientData(nextCodcli);
      fetchDadosSocio(nextCodcli);
    };

    window.addEventListener("openSidebar", handleOpenSidebar);
    return () => window.removeEventListener("openSidebar", handleOpenSidebar);
  }, [clearFormData, fetchClientData, fetchDadosSocio]);

  useEffect(() => {
    setTipoemp(localStorage.getItem("tipoemp"));
  }, []);

  useEffect(() => {
    if (tipoemp && typeof tipoemp === "string") {
      setTitulo(tipoemp.slice(0, 2) === "10" ? "Sindicalizado" : "Cliente");
    }
  }, [tipoemp]);

  const handleDataChange = (updatedData) => {
    setDadosCliente((current) => ({
      ...current,
      ...updatedData,
    }));
  };

  const handleSocioChange = (updatedData) => {
    setDadosSocio((current) => ({
      ...current,
      ...updatedData,
    }));
  };

  const handleCancelar = () => {
    setShow(false);
  };

  const saveSocio = async (clientId, params) => {
    if (!dadosSocio) {
      return;
    }

    const socioParaSalvar = normalizeSocioPayload(dadosSocio, clientId);
    const codSocio = socioParaSalvar.AUTOCOD;

    if (codSocio) {
      await api.put(`/t_socio/${codSocio}?${params}`, socioParaSalvar);
      return;
    }

    delete socioParaSalvar.AUTOCOD;
    await api.post(`/t_socio?${params}`, socioParaSalvar);
  };

  const handleSalvar = async () => {
    const params = new URLSearchParams({
      user: localStorage.getItem("user"),
      cliente: codcli || "",
      gmt: "-04:00",
    });

    if (!dadosCliente) {
      alert("Dados do cliente nao carregados.");
      return;
    }

    const clienteParaSalvar = normalizeClientePayload(dadosCliente);

    try {
      let clientId = codcli;

      if (clientId) {
        const response = await api.put(
          `/t_cli/${clientId}?${params}`,
          clienteParaSalvar,
        );
        clientId = String(response.data?.cdcli || clientId);
      } else {
        delete clienteParaSalvar.cdcli;
        const response = await api.post(`/t_cli?${params}`, clienteParaSalvar);
        clientId = String(response.data?.cdcli || "");
        setCodcli(clientId);
      }

      if (!clientId) {
        throw new Error("Codigo do cliente nao retornado pelo backend.");
      }

      await saveSocio(clientId, params);

      window.dispatchEvent(new CustomEvent("clientesAtualizados"));
      window.alert("Dados salvos com sucesso!");
      setShow(false);
    } catch (error) {
      console.error("Erro ao salvar cliente:", error);
      window.alert("Erro ao salvar as informacoes do cliente.");
    }
  };

  return (
    <Dock position="right" isVisible={show} fluid={false} size={620}>
      <div className="container-fluid h-100 pt-4 sidebar p-4">
        <h4 className="d-inline">
          {operacao === "edit" ? `Editar ${titulo}` : `Novo ${titulo}`}
        </h4>
        <div className="row tela-cad">
          <ClienteInfoTabs
            formData={dadosCliente}
            operacao={operacao}
            onDataChange={handleDataChange}
            Socio={dadosSocio}
            onSocioChange={handleSocioChange}
          />
        </div>
        <div className="row align-items-end footer">
          <div className="text-center">
            <button
              className="btn btn-outline-primary me-3"
              onClick={handleCancelar}
            >
              Cancelar
            </button>
            <button className="btn btn-primary" onClick={handleSalvar}>
              Salvar Dados
            </button>
          </div>
        </div>
      </div>
    </Dock>
  );
}

export default ClienteCad;
